import React, { useEffect, useState } from 'react'
import { ALL_AFFINITY_TABLE, NEWSLETTER_ALL_TRIGGERS_TABLE_KEYS } from '../../helper';
import useAxiosInstance from '../../hooks/useAxios';
import { TableCustom } from '../../components/Table';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AllAffinity = () => {
  const [isLoading,setIsLoading] = useState(false);
    const [triggers,setTriggers] = useState([]);
    const history = useNavigate()
    const [retrigger, setRetrigger] = useState(0);
    // const history = useNavigate()
    const axiosInstance = useAxiosInstance();
    useEffect(() => {
          setIsLoading(true);
          axiosInstance
            .get("/integrations/affinity/get_affinity_configs/")
            .then((res) => {
              setIsLoading(false);
              setTriggers(res?.data?.data);
            })
            .catch((err) => {
              setIsLoading(false);
            });
      }, [retrigger]);
    
      
  return (
    <div className="w-full px-6">
          <p className='text-2xl font-medium mt-5 px-4 py-2 bg-white border rounded-xl'>All Affinity Configs</p>  
          <TableCustom
            columns={ALL_AFFINITY_TABLE}
            data={{'data':triggers}}
            loading={isLoading}
            handleEdit={(id)=>history('/edit-affinity/'+id)}
            handleDelete={(id)=>{
              setIsLoading(true)
              axiosInstance.post('integrations/affinity/delete/',{'unique_affinity_id':id}).then(res=>{
                setIsLoading(false)
                toast.success('deleted')
                setRetrigger(prev=>prev+1)
              }).catch(()=>{
                toast.error('something went wrong!')
              })
            }
            }
            handleSelect={null}
            className="max-w-full"
        />     
        <button 
        className='px-2 py-1 bg-black text-sm text-white rounded-lg mt-3'
        onClick={()=>{
          history('/add-affinity/')
        }}>Add Config</button>   
        </div>
  )
}

export default AllAffinity